import GoogleAnalytics from 'react-ga';


const settings = {

	GA_ID : ' UA-44314724-1' // Analytics ID

}

/*
	Init GA
*/

GoogleAnalytics.initialize({

    trackingId: settings.GA_ID,
    debug: true
  
});

export default settings;





// WEBPACK FOOTER //
// ./src/js/data/settings.js